import { State } from '../StateTypes';
import { Itemid } from '../../generalTypes';
import { Product } from './productsTypes';

/**
 * Selects related ids by id
 *
 * @param state {object}
 * @param id {string}
 * @returns {*}
 */
export const selectRelatedIdsById = (
  state: State,
  id: Itemid
): Product | undefined =>
  state.products.find(({ products }) => products.includes(id));
